// extracted by mini-css-extract-plugin
export var postLoadCard = "loading-module--postLoadCard--3gsCg";
export var loadingAnim = "loading-module--loadingAnim--3RpjI";
export var loadingText = "loading-module--loadingText--eQOAk";
export var loadanimation = "loading-module--loadanimation--3R5kR";
export var bodyWrap = "loading-module--bodyWrap--3-zLo";
export var footerWrap = "loading-module--footerWrap--ktDd2";